/**
 * Created by portiz 2019/01/23.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import Select from 'react-select';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handles the selection of the available currencies
 */
class SelectorBillingInterval extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        this.state = {
            options: [], // The options to fill the selection
            value: null,
            disabled: props.disabled
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            disabled: nextProps.disabled,
            value: nextProps.value
        });
    }

    /**
     * Call the data API
     */
    callData(){
        // This is promise
        let apiCall = ApiCalls.getBillingInterval();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{
            // Now fill the selections
            for (let i = 0; i < data.BillingIntervals.length; i++) {
                arrOptions.push({ value: data.BillingIntervals[i].BillingInterval.Value,
                    label: data.BillingIntervals[i].BillingIntervalLang[0].Desc });
            }
        }).then(() =>{
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Call the webservices for the subscription and fill those selects
     * Component did mount is required for selects with API calls.
     */
    componentWillMount()
    {
        this.callData();
    }

    /**
     * Handles the change event to get the selected value. Do not change this function
     * @param event The event (on change)
     */
    handleChange = (object) => {
        this.setState({value: object.value === "0" ? null : object.value}, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Select value={this.state.options.filter(option => option.value === this.state.value)}
                    isDisabled={this.state.disabled} options={this.state.options} name="plans" onChange={this.handleChange} placeholder=
                {
                    <Translate id="billing-interval.billing-interval-select" options={{renderInnerHtml: false}}/>
                }
            />
        )
    }
}

export default SelectorBillingInterval;